import type { PositionCategory } from 'store/admins/types';
import { PositionCategoryOptions } from 'views/Admins/constants';

// This form offers no free-text alternative, so it filters the shared list rather than forking
// it. Keyed on PositionCategory rather than a list so a category added for staff fails the build
// here instead of silently not appearing in the dropdown.
const IS_OFFERED_TO_RECIPIENTS: Record<PositionCategory, boolean> = {
  CAMPAIGN_MANAGER: true,
  COMPLIANCE: true,
  OTHER: true,
};

export const POSITION_CATEGORY_OPTIONS = PositionCategoryOptions.filter(
  option => IS_OFFERED_TO_RECIPIENTS[option.value]
);

// Word for word refuse_at_active_admin_cap in backend/shared/helpers/recipient_admins.py, which
// refuses the add and the unarchive with this one sentence. Both paths reuse it so a client-side
// disable and a server refusal on the same over-limit account never read differently.
const atCapCopy = (activeCount: number, activeAdminLimit: number) => {
  const surplus = activeCount - activeAdminLimit + 1;
  return (
    `This account has ${activeCount} active admins and the limit is ${activeAdminLimit}. ` +
    `Archive ${surplus} ${surplus === 1 ? 'admin' : 'admins'} before adding another.`
  );
};

// TODO(OATH-4302): replace with final wording from Design before this ships to campaigns.
export const COPY = {
  emptyTable: 'No admins yet. Add one to get started.',
  atCap: atCapCopy,
  duplicateEmailWarning: 'This email is already on the list below.',
  primaryContactArchiveDisabledReason: "The Primary Contact can't be archived.",
  archiveConfirm: (name: string) =>
    `Archive ${name}? They will lose access to this account. Access to any other recipients they manage is unaffected. You can restore them later.`,
  restoreConfirm: (name: string) =>
    `Restore ${name}'s access to this account? Access to any other recipients is unaffected.`,
};
